import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/basket_icon.svg'


const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = {
  class: "name",
  alt: "Blob pattern"
}
const _hoisted_3 = {
  key: 1,
  class: "name",
  alt: "Blob pattern"
}
const _hoisted_4 = { class: "card-data-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["RenewBasketPlanModal"], { ref: "renewBasketPlanModal" }, null, 512 /* NEED_PATCH */),
    _createElementVNode("div", {
      class: _normalizeClass(["card-father", {
    'card-father-hover': $setup.thisInstance?.vnode?.props?.changePage,
  }]),
      onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('change-page'))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          width: "27"
        }, null, -1 /* HOISTED */)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { style: {"height":"14px"} }, null, -1 /* HOISTED */)),
        _createVNode($setup["CurrencyValue"], {
          value: $props.basketPlan.getValue(),
          fontReal: 28,
          fontSize: 16,
          color: "pink"
        }, null, 8 /* PROPS */, ["value"]),
        ($props.basketPlan.getName().length >= $setup.textEllipsisSize)
          ? (_openBlock(), _createBlock($setup["Tooltip"], {
              key: 0,
              text: $props.basketPlan.getName()
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_2, _toDisplayString($setup.FormatUtils.ellipsis($props.basketPlan.getName(), $setup.textEllipsisSize)), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["text"]))
          : (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString($props.basketPlan.getName()), 1 /* TEXT */)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-200, 16px)"} }, null, -1 /* HOISTED */)),
        _createVNode($setup["UserCountComponent"], {
          usersCount: $props.basketPlan.getUsersCount() ?? 0
        }, null, 8 /* PROPS */, ["usersCount"]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-inline-100, 8px)"} }, null, -1 /* HOISTED */)),
        _createVNode($setup["StatusPlan"], { basketPlan: $props.basketPlan }, null, 8 /* PROPS */, ["basketPlan"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        ($props.basketPlan.isActive())
          ? (_openBlock(), _createBlock($setup["BasketPlanStatus"], {
              key: 0,
              basketPlan: $props.basketPlan
            }, null, 8 /* PROPS */, ["basketPlan"]))
          : _createCommentVNode("v-if", true)
      ]),
      (!$props.hideControls)
        ? (_openBlock(), _createBlock($setup["ContextMenu"], {
            key: 0,
            class: "context-menu",
            buttons: [
        {
          text: 'Renovar',
          action: () => $setup.set2FAUser($setup.renew),
          visible: $setup.LoggedAdminStorage.getUser()?.getIsSuperAdmin()
            && !$props.basketPlan.getWasPaid()
            && Boolean($props.basketPlan.getUsersCount()),
        },
        {
          text: 'Pedir renovação',
          visible: !$setup.LoggedAdminStorage.getUser()?.getIsSuperAdmin()
            && $setup.LoggedAdminStorage.getUser()?.hasPermissions([$setup.Permission.fromResource($setup.Resource.BASKET_PLANS, 'write')])
            && !$props.basketPlan.getWasPaid()
            && Boolean($props.basketPlan.getUsersCount()),
          action: () => _ctx.$emit('request-renew'),
        },
        {
          text: 'Atualizar sortimento',
          action: () => $setup.router.push({
            name: $setup.routes.updateCartProducts.name, params: {
              basketPlanId: $props.basketPlan.getId(),
            }
          }),
          visible: $setup.LoggedAdminStorage.getUser()?.getIsSuperAdmin(),
        },
        {
          text: 'Excluir',
          action: () => _ctx.$emit('remove'),
          visible: true
        }
      ]
          }, null, 8 /* PROPS */, ["buttons"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["CardBlob"], {
        class: "blob",
        fill: "#FF508C"
      })
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}